import { ServerObjectSchema as OriginalServerObjectSchema } from '../processed/server-object'
/**
 * Server Object
 *
 * An object representing a Server.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#server-object
 */
export const ServerObjectSchema = OriginalServerObjectSchema
